import { forwardRef, type InputHTMLAttributes } from "react";
import s from "./TextInput.module.css";

export interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(function TextInput(
  { invalid, className, "aria-invalid": ariaInvalid, ...rest },
  ref,
) {
  const classes = className ? `${s.root} ${className}` : s.root;
  return (
    <input
      ref={ref}
      className={classes}
      aria-invalid={ariaInvalid ?? invalid}
      {...rest}
    />
  );
});
